// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.caller-modal-body {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 0.5rem;
  text-align: center;
}

.caller-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.caller-name {
  color: var(--text-primary);
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.75rem;
  margin: 0;
}

.participant-type-text {
  color: var(--text-secondary);
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin: 0;
}

#dismiss {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/caller-modal/caller-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;;AAEA;EACI,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,SAAA;AACJ;;AAEA;EACI,4BAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;AACJ;;AAIA;EACI,aAAA;AADJ","sourcesContent":[":host {\n    display: block;\n}\n\n.caller-modal-body {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding-top: 0.5rem;\n    text-align: center;\n}\n\n.caller-details {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.caller-name {\n    color: var(--text-primary);\n    font-size: 1.25rem;\n    font-weight: 700;\n    line-height: 1.75rem;\n    margin: 0;\n}\n\n.participant-type-text {\n    color: var(--text-secondary);\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    margin: 0;\n}\n\n// .modal-footer inherits justify-content: center from global.scss\n\n#dismiss {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
